import React from "react";
import { Link } from "react-router-dom";

export default class  HeroThree extends React.Component {
  componentDidMount() {
    const $ = window.$;

    if ($(".slider-carousel").length) {
      $(".slider-carousel").owlCarousel({
        animateOut: "fadeOut",
        animateIn: "fadeIn",
        loop: true,
        margin: 0,
        nav: false,
        singleItem: true,
        smartSpeed: 500,
        autoplay: true,
        autoplayTimeout: 6000,
        navText: [
          '<span class="icon-right-arrow"></span>',
          '<span class="icon-right-arrow"></span>',
        ],
        responsive: {
          0: {
            items: 1,
          },
          600: {
            items: 1,
          },
          1024: {
            items: 1,
          },
        },
      });
    }
  }
  render() {
    let publicUrl = process.env.PUBLIC_URL + "/";
    return (
      <>
        <section className="slider-one-sec">
          <div className="slider-carousel owl-carousel owl-theme">
            {/* Start Slider One Single */}
            <div className="slider-one__single">
              <div
                className="image-layer"
                style={{
                  backgroundImage:
                    "url(" +
                    publicUrl +
                    "assets/images/slider/slider-v1-img1.webp)",
                }}
              ></div>
              <div className="container">
                <div className="row clearfix">
                  <div className="col-xl-12">
                    <div className="slider-one__single-content">
                      <h3>Stonehenge Masonry & Construction</h3>
                      <h2>Building Timeless Stone Creations</h2>
                      <p>
                        Specializing in custom patios, fire features, and
                        restorations, we bring your vision to life with expert
                        craftsmanship.
                      </p>
                      <div className="btn-box">
                        <Link
                          to={`/`}
                          className="thm-btn"
                          data-text="Read More +"
                        >
                          Read More +
                        </Link>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            {/* End Slider One Single */}

            {/* Start Slider One Single */}
            <div className="slider-one__single">
              <div
                className="image-layer"
                style={{
                  backgroundImage:
                    "url(" +
                    publicUrl +
                    "assets/images/slider/slider-v1-img2.jpg)",
                }}
              ></div>
              <div className="container">
                <div className="row clearfix">
                  <div className="col-xl-12">
                    <div className="slider-one__single-content">
                      <h3>Stonehenge Masonry & Construction</h3>
                      <h2>Transforming Residential Landscapes</h2>
                      <p>
                        We focus on creating beautiful and durable stone
                        installations that enhance your home's value and appeal.
                      </p>
                      <div className="btn-box">
                        <Link
                          to={`/`}
                          className="thm-btn"
                          data-text="Read More +"
                        >
                          Read More +
                        </Link>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            {/* End Slider One Single */}

            {/* Start Slider One Single */}
            <div className="slider-one__single">
              <div
                className="image-layer"
                style={{
                  backgroundImage:
                    "url(" +
                    publicUrl +
                    "assets/images/slider/slider-v1-img3.webp)",
                }}
              ></div>
              <div className="container">
                <div className="row clearfix">
                  <div className="col-xl-12">
                    <div className="slider-one__single-content">
                      <h3>Stonehenge Masonry & Construction</h3>
                      <h2>Building Your Outdoor Sanctuary</h2>
                      <p>
                        From fire pits to retaining walls, we craft outdoor
                        spaces that reflect your unique style and needs.
                      </p>
                      <div className="btn-box">
                        <Link
                          to={`/`}
                          className="thm-btn"
                          data-text="Read More +"
                        >
                          Read More +
                        </Link>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div className="slider-one__single">
              <div
                className="image-layer"
                style={{
                  backgroundImage:
                    "url(" +
                    publicUrl +
                    "assets/images/slider/slider-v2-img1.webp)",
                }}
              ></div>
              <div className="container">
                <div className="row clearfix">
                  <div className="col-xl-12">
                    <div className="slider-one__single-content">
                      <h3>Stonehenge Masonry & Construction</h3>
                      <h2>Restoring Stone's Natural Beauty</h2>
                      <p>
                        Our restoration services preserve the beauty and
                        integrity of your stone structures, ensuring they last
                        for generations.
                      </p>
                      <div className="btn-box">
                        <Link
                          to={`/`}
                          className="thm-btn"
                          data-text="Read More +"
                        >
                          Read More +
                        </Link>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            {/* End Slider One Single */}
          </div>
        </section>
      </>
    );
  }
}
